
interface JournalAccountEntryCellDelegate
{
    addEntryDidPress(cell:JournalAccountEntryCell, journalEntry:AccountingJournalEntry):void;
}

class JournalAccountEntryCell extends UITableViewCell
{
    delegate:JournalAccountEntryCellDelegate = null;

    private accountTextField:MUITextField = null;
    private accountLabel:MUILabel = null;
    private accountDropdown:MUIButton = null;
    private accountNameLabel:MUILabel = null;

    private referenceTextField:MUITextField = null;
    private referenceLabel:MUILabel = null;
    private debitTextField:MUITextField = null;
    private debitLabel:MUILabel = null;
    private credictTextField:MUITextField = null;
    private credictLabel:MUILabel = null;

    private cf = ( MUIWebApplication.sharedInstance().delegate as AppDelegate ).currencyFormatter;

    private _account:LedgerAccount = null;
    private _reference:string = null;
    private _debitAmount:number = 0;
    private _creditAmount:number = 0;

    journalEntry:AccountingJournalEntry = null;

    awakeFromHTML()
    {
        this.accountLabel = MUIOutlet(this, "account-lbl", "MUILabel");
        this.accountTextField = MUIOutlet(this, "account-tf", "MUITextField");
        if (this.accountTextField) this.accountTextField.setOnChangeText(this, function(this:JournalAccountEntryCell, control:MUITextField, value:string){
            this.showSelectLedgerAccountViewController( value.length > 0 ? value : null, true );
        });

        this.accountNameLabel = MUIOutlet(this, "account-name-lbl", "MUILabel");
        this.accountDropdown = MUIOutlet(this, "account-dd", "MUIButton");
        if (this.accountDropdown) this.accountDropdown.setAction(this, function(){
            this.showSelectLedgerAccountViewController( null, false );
        });

        this.referenceLabel = MUIOutlet(this, "reference-lbl", "MUILabel");
        this.referenceTextField = MUIOutlet(this, "reference-tf", "MUITextField");
        if (this.referenceTextField) {
            this.referenceTextField.setOnChangeText(this, function(this:JournalAccountEntryCell, textField:MUITextField, value:string){
                this._reference = value.trim().length > 0 ? value : null;
            });
            this.setupEnterPress(this.referenceTextField);
        }

        this.debitLabel = MUIOutlet(this, "debit-lbl", "MUILabel");
        this.debitTextField = MUIOutlet(this, "debit-tf", "MUITextField");
        if (this.debitTextField) {
            this.debitTextField.setOnChangeText(this, function(this:JournalAccountEntryCell, textField:MUITextField, value:string){
                this._debitAmount = this.cf.numberFromString(value);
            });
            this.setupEnterPress(this.debitTextField);
        }

        this.credictLabel = MUIOutlet(this, "credict-lbl", "MUILabel");
        this.credictTextField = MUIOutlet(this, "credict-tf", "MUITextField");
        if (this.credictTextField) {
            this.credictTextField.setOnChangeText(this, function(this:JournalAccountEntryCell, textField:MUITextField, value:string){
                this._creditAmount = this.cf.numberFromString(value);
            });
            this.setupEnterPress(this.credictTextField);
        }

        this.selectionStyle = UITableViewCellSelectionStyle.None;
    }

    private _item:AccountingEntry = null;
    set item(item:AccountingEntry)
    {
        this._item = item;
        this._account = item.account;

        if (this.accountLabel) this.accountLabel.text = item.accountNumber;
        if (this.accountNameLabel) this.accountNameLabel.text = item.accountName;
        if (this.referenceLabel) this.referenceLabel.text = item.reference;
        if (this.debitLabel) this.debitLabel.text = this.cf.stringFromNumber(item.debitAmount);
        if (this.credictLabel) this.credictLabel.text = this.cf.stringFromNumber(item.creditAmount);
    }

    get account():LedgerAccount { return this._account; }
    get reference():string { return this._reference; }
    get debitAmount():number { return this._debitAmount; }
    get creditAmount():number { return this._creditAmount; }

    private showSelectLedgerAccountViewController( searchString:string, hideSearchBar:boolean = false){
        AppHelper.sharedInstance().showSelectLedgerAccountViewControllerFromView(this.accountDropdown, null, searchString, hideSearchBar, null, this, this.updateLedgerAccount);
    }

    private updateLedgerAccount(controller:SelectViewController, account:LedgerAccount){
        this._account = account;
        if (this.accountDropdown) this.accountDropdown.title = account.description;
        if (this.accountTextField) this.accountTextField.text = account.prefix;
    }

    private setupEnterPress(textField:MUITextField){
        textField.setOnEnterPress(this, function(control:MUITextField){
            control.resignFirstResponder();
            this.delegate?.addEntryDidPress(this, this.journalEntry);
        });
    }
}
